import { render } from "./ViewClients.vue?vue&type=template&id=2172a86e&scoped=true"
import script from "./ViewClients.vue?vue&type=script&lang=js"
export * from "./ViewClients.vue?vue&type=script&lang=js"

import "./ViewClients.vue?vue&type=style&index=0&id=2172a86e&scoped=true&lang=css"
import "./ViewClients.vue?vue&type=style&index=1&id=2172a86e&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2172a86e"]])

export default __exports__